import GetProjectByTemplateSlug from './queries/get-project-by-template-slug.graphql';
import GetProjectByUuid from './queries/get-project-by-uuid.graphql';
import GetProjectPresets from './queries/get-project-presets.graphql';
import GetStickers from './queries/get-stickers.graphql';
import SendAiChat from './queries/send-ai-chat.graphql';
import GetTemplate from './queries/get-template.graphql';
import Templates from './queries/get-templetes.graphql';
import ChatBotReset from './queries/chat-bot-reset.graphql';
import ThreedBaseModel from './queries/get-base-model-by-uuid.graphql';
import GetCompanyProjects from './queries/get-company-projects.graphql';
import CompanyProject from './queries/get-company-project.graphql';
import GetTemplateByUuid from './queries/get-template-by-uuid.graphql';
import GetEmbedProjectUuid from './queries/get-embed-project-by-uuid.graphql';
import ThreedPartModels from './queries/get-part-models.graphql';
import ProjectPreset from './queries/get-preset.graphql';

import CreateProjectPreset from './mutations/create-project-preset.graphql';
import CreateProject from './mutations/create-project.graphql';
import DeleteProjectPreset from './mutations/delete-project-preset.graphql';
import GenerateImage from './mutations/generate-image.graphql';
import GenerateLivery from './mutations/generate-livery.graphql';
import ImageUpload from './mutations/image-upload.graphql';
import TranslateKoToEn from './mutations/translate-ko-to-en.graphql';
import CreateCompanyProjects from './mutations/create-company-project.graphql';
import EmbedProjectCreate from './mutations/create-embed-project.graphql';
import EmbedProjectDelete from './mutations/delete-embed-project.graphql';
import CompanyProjectsUpdate from './mutations/update-company-project.graphql';
import EmbedProjectUpdate from './mutations/update-embed-project.graphql';
import EmbedProjectAddPartModel from './mutations/add-partmodel-in-embed-project.graphql';
import EmbedProjectDeletePartModel from './mutations/delete-partmodel-in-embed-project.graphql';
import ThreedPartCategories from './queries/get-threed-part-categories.graphql';
import ThreedPartModel from './queries/get-part-model-by-uuid.graphql';
import EmbedProjectPresetAdd from './mutations/add-embed-project-preset.graphql';
import EmbedProjectPresetDelete from './mutations/delete-embed-project-preset.graphql';
import EmbedProjectMainPresetUpdate from './mutations/create-embed-project-main-preset-update.graphql';
import CompanyProjectsDelete from './mutations/delete-company-project.graphql';

export {
  GetTemplate,
  CreateProject,
  GetProjectByTemplateSlug,
  GetProjectByUuid,
  GetProjectPresets,
  GetStickers,
  SendAiChat,
  CreateProjectPreset,
  DeleteProjectPreset,
  GenerateImage,
  GenerateLivery,
  ImageUpload,
  TranslateKoToEn,
  Templates,
  ChatBotReset,
  ThreedBaseModel,
  GetCompanyProjects,
  CreateCompanyProjects,
  EmbedProjectCreate,
  CompanyProject,
  EmbedProjectDelete,
  CompanyProjectsUpdate,
  EmbedProjectUpdate,
  GetTemplateByUuid,
  EmbedProjectAddPartModel,
  EmbedProjectDeletePartModel,
  GetEmbedProjectUuid,
  ThreedPartCategories,
  ThreedPartModels,
  ThreedPartModel,
  EmbedProjectPresetAdd,
  EmbedProjectPresetDelete,
  EmbedProjectMainPresetUpdate,
  ProjectPreset,
  CompanyProjectsDelete,
};
